import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../utils/axiosInstance";
import { Card, CardBody, Badge, Spinner } from "../components/ui";
import { FaCheckCircle } from "react-icons/fa";

export default function Success() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");

  const [session, setSession] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        // Fetch checkout session details if session_id is present
        if (sessionId) {
          const sessionRes = await api.get(`/api/checkout/session/${sessionId}`);
          if (sessionRes.data?.success) setSession(sessionRes.data.session);
        }
        // Fetch current subscription
        const subRes = await api.get("/api/me/subscription");
        if (subRes.data?.success) setSubscription(subRes.data);
      } catch (err) {
        console.error("Failed to fetch details:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [sessionId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-bg">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="mt-4 text-ink-muted">Confirming your payment...</p>
        </div>
      </div>
    );
  }

  const planName = subscription?.plan?.name || session?.metadata?.planKey || "your plan";
  const amountPaid = session?.amount_total ? `$${(session.amount_total / 100).toFixed(2)}` : null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-bg p-4">
      <Card className="max-w-md w-full text-center">
        <CardBody className="py-10 px-8">
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "rgba(0,200,151,0.1)" }}
          >
            <FaCheckCircle size={32} className="text-brand" />
          </div>

          <h1 className="text-2xl font-bold text-ink-primary mb-2">Payment Successful!</h1>
          <p className="text-ink-muted mb-6">Thank you for subscribing. Your plan is now active.</p>

          <div className="space-y-3 mb-8 text-left">
            <div className="flex justify-between p-3 rounded-lg bg-surface-bg">
              <span className="text-sm text-ink-muted">Plan</span>
              <span className="text-sm font-semibold text-ink-primary">{planName}</span>
            </div>
            <div className="flex justify-between p-3 rounded-lg bg-surface-bg">
              <span className="text-sm text-ink-muted">Status</span>
              <Badge variant="success">Active</Badge>
            </div>
            {amountPaid && (
              <div className="flex justify-between p-3 rounded-lg bg-surface-bg">
                <span className="text-sm text-ink-muted">Amount Paid</span>
                <span className="text-sm font-semibold text-ink-primary">{amountPaid}</span>
              </div>
            )}
            {subscription?.subscription?.interval && (
              <div className="flex justify-between p-3 rounded-lg bg-surface-bg">
                <span className="text-sm text-ink-muted">Billing</span>
                <span className="text-sm font-semibold text-ink-primary capitalize">
                  {subscription.subscription.interval}ly
                </span>
              </div>
            )}
          </div>

          <button
            className="btn-primary w-full"
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </button>
        </CardBody>
      </Card>
    </div>
  );
}
